module.exports = __webpack_public_path__ + "img/droplet_blue.8ebbbb16.svg";